import translate from "@insite/client-framework/Translate";
import React from "react";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ADIBrandsRewardsModal from "@NA/Components/ADIBrandsRewardsModal";
import Link from "@insite/mobius/Link";
import Img from "@insite/mobius/Img/Img";
import { hmiSettingsBrandImages } from "@NA/Utils/Utility";
import { BrandImageLoyalityModel } from "@NA/Widgets/LoyaltyRewards/LoyaltyRewardsModel";
import { useSelector } from "react-redux";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";

export interface ADIExclusivebrandsStyles {
    ADIExclusivebrandsStyles?: ADIExclusivebrandsStyles;
}

interface OwnProps {
    closeLoyaltyModal: Function;
    isLoyaltyModalOpen: boolean;
}

type Props = OwnProps;

const ADIExclusiveBrands = ({ closeLoyaltyModal, isLoyaltyModalOpen }: Props) => {

    const brandModalArray = hmiSettingsBrandImages();
    const hmiRewardsSettingSettings:any = useSelector(
        (state: CustomApplicationState) => state.context.settings.settingsCollection.hmiRewardsSettingSettings,
    );


    return (
        <ADIBrandsRewardsModal
            errorStyle={true}
            headline={translate(
                hmiRewardsSettingSettings.exclusiveBrandsPopupTitle
            )}
           // subheading={translate("Earn 1 extra point for every $1 spent on ADI Exclusive Brands.")}
            subheading={translate(
                hmiRewardsSettingSettings.exclusiveBrandsPopupText
            )}
            isOpen={isLoyaltyModalOpen}
            handleClose={closeLoyaltyModal}
        >
            <>
                <GridContainer data-test-selector="navigationList" as="ul">
                    <StyledWrapper className="adiexclusivesection popup-scroll-height-webkit">
                        {brandModalArray &&
                            brandModalArray.map((item: BrandImageLoyalityModel) => (
                                <GridItem as="li" key={item.id}>
                                    <Link
                                        href={item.imageLink}
                                        target="_self"
                                        data-test-selector="navigationList-Addresses"
                                        data-ga-promo={"ADI-loyalty_ADI-Exclusive-" + item.brandName}
                                    >
                                        <Img src={item.imageUrl} alt="ADI Pro Logo" />
                                    </Link>
                                </GridItem>
                            ))}
                    </StyledWrapper>
                </GridContainer>
            </>
        </ADIBrandsRewardsModal>
    );
};

export default ADIExclusiveBrands;
